var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWebcam = function SvgWebcam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Camera Iocn"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2930"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2920"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    d: "M6.396 61.63c0-5.2 5.4-9.793 13.671-12.6a26.1 26.1 0 1 1 37.722-.048c8.357 2.8 13.814 7.421 13.814 12.647 0 8.545-14.6 15.472-32.6 15.472S6.396 70.175 6.396 61.63Zm17.757-30.634a14.752 14.752 0 1 0 14.753-14.752 14.77 14.77 0 0 0-14.753 14.752Z",
    "data-name": "Union 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#495867",
    d: "M38.848 22.67a8.215 8.215 0 0 1 7.938 8.467 8.215 8.215 0 0 1-7.938 8.467 8.215 8.215 0 0 1-7.938-8.467 8.215 8.215 0 0 1 7.938-8.467",
    "data-name": "Path 6111"
  }))))));
};
export default SvgWebcam;